import React from "react";

// imgBottom1
const imgMiddle1 = {
  img1: "img_cityOrganic/nave-tata1_c.jpg",
  alt1: "image city Organic",
};
// imgMiddle2
const imgMiddle2 = {
  img2: "img_cityOrganic/nave-tata1.jpg",
  alt2: "image city Organic",
};
//
class OrganicCityimgMiddle extends React.Component {
  render() {
    //
    //
    //
    const { img1, alt1 } = imgMiddle1;
    const { img2, alt2 } = imgMiddle2;
    //

    //
    return (
      <div className="cityOrganic__imgMiddle_wrapper">
        <div className="cityOrganic__imgMiddle_container">
          <div className="boxImg">
            <img src={img1} alt={alt1} />
          </div>
          <div className="boxImg">
            <img src={img2} alt={alt2} />
          </div>
        </div>
      </div>
    );
  }
}
export default OrganicCityimgMiddle;
